export default __webpack_public_path__ + "i18n/translations/translation-fr.51b2f98a.json";